import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { OTHER_REQUESTS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function ViewOtherRequestsPage() {
  useRequireSectionVisible("showOtherRequests");
  return <CommunityViewPage section={OTHER_REQUESTS} />;
}
